import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  grey1,
  grey3,
  grey5,
  grey6,
  grey7,
  grey9,
  purple2,
  purple6,
  purple7,
} from 'approot/shared/styles/colours.style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const MultipleChoiceCheckboxFocus = styled.div`
  input:focus ~ & {
    position: absolute;
    left: -${rem(2)};
    width: ${rem(28)};
    height: ${rem(28)};
    border-radius: ${rem(28)};
    box-shadow: 0 0 0 4px ${purple2};
    background-color: ${purple2};
    z-index: 1;
    background-color: ${purple2};
  }
`;

type CheckboxLabelProps = {
  $disabled?: boolean;
};

export const MultipleChoiceCheckboxLabel = styled.label<CheckboxLabelProps>`
  display: flex;
  align-items: center;
  color: ${grey9};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  position: relative;
  margin: 0;

  ${({ $disabled }) =>
    $disabled &&
    `
      color: ${grey6};
      ${MultipleChoiceCheckboxDecor} {
        border: 1px solid ${grey5};
      }
  `};
`;

export const MultipleChoiceCheckboxInput = styled.input`
  cursor: pointer;
  opacity: 0;
  position: absolute;
  z-index: 1;
`;

type MultipleChoiceCheckboxDecorProps = {
  $isSelected?: boolean;
};

export const MultipleChoiceCheckboxDecor = styled.div<MultipleChoiceCheckboxDecorProps>`
  ${flexCentreAlignCss}
  background-color: ${grey3};
  border: 1px solid ${grey7};
  border-radius: ${rem(4)};
  flex-shrink: 0;
  height: ${rem(24)};
  width: ${rem(24)};
  margin-right: ${rem(spacing8)};
  z-index: 2;

  svg {
    display: none;
  }

  // HOVER STATES
  input:hover:not(:disabled) + & {
    border: 1px solid ${purple6};
  }

  input:hover:not(:disabled):checked + & {
    border: 1px solid ${purple7};
    background-color: ${purple7};
  }

  // DISABLED STATES
  input:disabled + & {
    background-color: ${grey3};
    border: 1px solid ${grey5};
    cursor: not-allowed;
  }

  input:disabled:checked + & {
    background-color: ${grey3};
    border: 1px solid ${grey5};
    svg {
      stroke: ${grey6};
      display: block;
    }
  }

  // ACTIVE STATES
  input:checked + & {
    border: 1px solid ${purple7};
    background-color: ${purple7};

    svg {
      stroke: white;
      display: block;
    }
  }

  ${({ $isSelected }) =>
    $isSelected &&
    `
      border: 1px solid ${purple7};
      background-color: ${purple7};
      svg {
        stroke: ${grey1};
        display: block;
      }
    `}
`;
